export default __webpack_public_path__ + "assets/production.896bed0f.svg";